export default function ProfileView({
    profile,
  }) {

    return(
    <div className="grid pt-32">
      <div className="max-w-md mx-auto mt-10 p-10 shadow-md rounded-xl flex flex-col items-center bg-gray-100">
          <img src={`${process.env.REACT_APP_MEDIA}/media/${profile&&profile.profile_picture}`} className="size-32 rounded-full" />
          <div className="mt-10 mx-auto">
              <div className="flex justify-center">
                <span className="block text-gray-800 text-2xl mr-2 font-semibold">{profile&&profile.first_name}</span>
                <span className="block text-gray-800 text-2xl mr-2 font-semibold">{profile&&profile.last_name}</span>
                <span className="block text-gray-800 text-2xl font-semibold">{profile&&profile.second_last_name}</span>
              </div>
              <div className="flex justify-center">
                <span className="block text-gray-800 text-lg mr-2">{profile&&profile.email}</span>
              </div>
          </div>
      </div>
   </div>

    )
  }